import React from 'react';
import { SDLogo } from '@/components/atoms';

export default function OnboardingLayout({ step = 0, children }) {
  const dots = [0, 1, 2, 3];
  return (
    <div className="min-h-screen flex bg-sd-ivory">
      <aside className="hidden lg:flex flex-col w-[380px] bg-sd-black text-white p-10 sticky top-0 h-screen">
        <SDLogo color="#FFFFFF" accent="#4CD964" />
        <div className="mt-14">
          <p className="text-[12px] uppercase tracking-[0.14em] text-[#7AB089] font-medium mb-4">Career intelligence</p>
          <h1 className="text-[34px] font-semibold leading-[1.1] heading-mega">
            Your sustainability career is worth more than you think.
          </h1>
          <p className="text-[14px] text-[#A8B0A8] mt-6 leading-relaxed">
            We read your profile, run it through a sustainability-specific analysis and surface the roles, salaries, gaps and actions that move you forward.
          </p>
        </div>

        <div className="mt-auto">
          <div className="flex gap-2 mb-4">
            {dots.map((i) => (
              <span
                key={i}
                className="h-1.5 rounded-full transition-all"
                style={{
                  width: i === step ? 28 : 12,
                  background: i <= step ? '#4CD964' : '#3A3A3D',
                }}
              />
            ))}
          </div>
          <p className="text-[12px] text-[#7A7F7A] leading-relaxed" data-testid="consent-primary">
            We only use your data to generate your analysis. We don’t sell or share it. You can delete it anytime.
          </p>
          <p className="text-[12px] text-[#7A7F7A] leading-relaxed mt-2" data-testid="consent-benchmark">
            We also use de-identified, aggregated data to build salary and skills benchmarks. This is stripped of anything that identifies you and can’t be traced back.
          </p>
        </div>
      </aside>

      <main className="flex-1 px-6 md:px-12 lg:px-16 py-12 overflow-y-auto">
        <div className="max-w-[760px] mx-auto animate-fade-in">
          {children}
        </div>
      </main>
    </div>
  );
}
